// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Caml_splice_call from "rescript/lib/es6/caml_splice_call.js";

function TcLevelDistribution(Props) {
  var group = Props.group;
  var match = Belt_Option.getWithDefault(Caml_option.undefined_to_opt(group.levels.find(function (param) {
                return param[0] === 6;
              })), [
        0,
        0,
        0
      ]);
  var l6c = match[1];
  var match$1 = Belt_Option.getWithDefault(Caml_option.undefined_to_opt(group.levels.find(function (param) {
                return param[0] === 7;
              })), [
        0,
        0,
        0
      ]);
  var l7c = match$1[1];
  var match$2 = Belt_Option.getWithDefault(Caml_option.undefined_to_opt(group.levels.find(function (param) {
                return param[0] === 8;
              })), [
        0,
        0,
        0
      ]);
  var l8c = match$2[1];
  var match$3 = Belt_Option.getWithDefault(Caml_option.undefined_to_opt(group.levels.find(function (param) {
                return param[0] === 9;
              })), [
        0,
        0,
        0
      ]);
  var l9c = match$3[1];
  var match$4 = Belt_Option.getWithDefault(Caml_option.undefined_to_opt(group.levels.find(function (param) {
                return param[0] === 10;
              })), [
        0,
        0,
        0
      ]);
  var l10c = match$4[1];
  var d1c = Global.f(l6c + l7c | 0) / Global.f(group.count);
  var d2c = Global.f(l8c) / Global.f(group.count);
  var d3c = Global.f(l9c + l10c | 0) / Global.f(group.count);
  var countDs = [
    d1c,
    d2c,
    d3c
  ];
  var maxCount = Caml_splice_call.spliceApply(Math.max, [countDs]);
  var d1p = Global.f(match[2] + match$1[2] | 0) / Global.f(l6c + l7c | 0);
  var d2p = Global.f(match$2[2]) / Global.f(l8c);
  var d3p = Global.f(match$3[2] + match$4[2] | 0) / Global.f(l9c + l10c | 0);
  var placeDs = [
    d1p,
    d2p,
    d3p
  ];
  var minPlace = Caml_splice_call.spliceApply(Math.min, [placeDs]);
  var maxPlace = Caml_splice_call.spliceApply(Math.max, [placeDs]);
  var placeDelta = maxPlace - minPlace + 0.1;
  return React.createElement("div", {
              className: "flex flex-col leading-none font-montserrat text-base font-semibold"
            }, Belt_Array.mapWithIndex([
                  "7-",
                  "8",
                  "9+"
                ], (function (idx, lvl) {
                    var place = Belt_Array.getExn(placeDs, idx);
                    return React.createElement("div", {
                                key: lvl,
                                className: "pt-[10px] flex items-center"
                              }, React.createElement("div", {
                                    className: "flex items-center justify-center w-[34px] h-[34px] bg-bg2 rounded"
                                  }, lvl), React.createElement("div", {
                                    className: "text-sm leading-none font-medium"
                                  }, React.createElement("div", {
                                        className: "flex"
                                      }, React.createElement("div", {
                                            className: "mx-2 bg-secondary-9 h-[14px]",
                                            style: Global.s({
                                                  width: (Belt_Array.getExn(countDs, idx) / maxCount * 175).toFixed() + "px"
                                                })
                                          }), React.createElement("div", undefined, Global.formatPct2(undefined, Belt_Array.getExn(countDs, idx)))), React.createElement("div", {
                                        className: "flex mt-[6px]"
                                      }, React.createElement("div", {
                                            className: "mx-2 bg-tertiary-9 h-[14px]",
                                            style: Global.s({
                                                  width: ((0.1 + (maxPlace - place)) / placeDelta * 175).toFixed() + "px"
                                                })
                                          }), React.createElement("div", undefined, Global.toFixed(undefined, place)))));
                  })));
}

var make = TcLevelDistribution;

export {
  make ,
  
}
/* react Not a pure module */
